import React from 'react';
type Tone = 'light' | 'dark';
export function Eyebrow({
  children,
  tone = 'light',
  align = 'center'
}: {
  children: React.ReactNode;
  tone?: Tone;
  align?: 'center' | 'left';
}) {
  return <p className={`mb-2 text-[11px] font-extrabold uppercase tracking-[.18em] md:text-xs ${align === 'center' ? 'text-center' : 'text-left'} ${tone === 'dark' ? 'text-sky-300' : 'text-blue-700'}`} data-id="element-254" data-mp="2vxarwwrr3qtv">
      {children}
    </p>;
}
export function SectionTitle({
  children,
  tone = 'light'
}: {
  children: React.ReactNode;
  tone?: Tone;
}) {
  return <h2 className={`mx-auto max-w-4xl text-center text-2xl font-black uppercase leading-tight md:text-4xl ${tone === 'dark' ? 'text-white' : 'text-blue-950'}`} data-id="element-255" data-mp="30xyjbjjw69om">
      {children}
    </h2>;
}
export function SectionLead({
  children,
  tone = 'light'
}: {
  children: React.ReactNode;
  tone?: Tone;
}) {
  return <p className={`mx-auto mt-4 max-w-2xl text-center text-base leading-relaxed md:text-lg ${tone === 'dark' ? 'text-white/80' : 'text-slate-600'}`} data-id="element-256" data-mp="1gg0pqdehq1fp">
      {children}
    </p>;
}
export function Mark({
  children
}: {
  children: React.ReactNode;
}) {
  return <span className="bg-yellow-300 box-decoration-clone px-1.5 text-blue-950" data-id="element-257" data-mp="29kmbrvccf10g">{children}</span>;
}